<div class="product-info-container info-card mb-4">
  <div class="card-header">
    @if (title) {
      <span class="card-title mb-0"> {{ title }} </span>
    }

    @if (sourceDataButton) {
      <button type="button" mat-button class="link" (click)="viewSourceData()">
        <mat-icon>preview</mat-icon>View Source
      </button>
    }
  </div>
  <table class="details vertical col-12">
    <tbody>
      @for (infoPoint of infoKey; track infoPoint.label) {
        @if (checkConditional(infoPoint)) {
          <tr>
            <th>{{ infoPoint.label }}</th>
            <td [class.empty-cell]="emptyCellCheck(infoPoint)">
              @if (infoPoint.varName === 'TaxBracketSource') {
                @if (tradeDetail.Details[infoPoint.varSet][infoPoint.varName]) {
                  {{ tradeDetail.Details[infoPoint.varSet][infoPoint.varName] }}
                } @else if (
                  tradeDetail.Details[infoPoint.varSet]['TaxBracket']
                ) {
                  {{
                    tradeDetail.Details[infoPoint.varSet]['TaxBracket']
                      | percent: '1.3'
                  }}
                }
              } @else if (infoPoint.rowLink) {
                <span class="decrypt-cell">
                  {{ tradeDetail.Details[infoPoint.varSet][infoPoint.varName] }}

                  @if (showRowLink(infoPoint)) {
                    <button
                      type="button"
                      class="ms-1 decrypt-button"
                      mat-icon-button
                      matTooltip="Click to Manage"
                      [matTooltipShowDelay]="500"
                      (click)="navigate(infoPoint)"
                    >
                      <mat-icon>launch</mat-icon>
                    </button>
                  }
                </span>
              } @else if (
                infoPoint.varSet &&
                tradeDetail.Details &&
                tradeDetail.Details[infoPoint.varSet] &&
                tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
              ) {
                @if (infoPoint.valueMask && infoPoint.valueMask === 'date') {
                  {{
                    tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
                      | date: 'shortDate'
                  }}
                } @else if (
                  infoPoint.valueMask && infoPoint.valueMask === 'currency'
                ) {
                  <span>
                    {{
                      tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
                        | currency
                    }}
                  </span>
                } @else if (
                  infoPoint.valueMask && infoPoint.valueMask === 'percent'
                ) {
                  <span>
                    {{
                      tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
                        | percent: '1.3'
                    }}
                  </span>
                } @else if (infoPoint.key) {
                  {{
                    infoPoint.key[
                      tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
                    ]
                  }}
                } @else if (
                  infoPoint.decryptTarget &&
                  tradeDetail[infoPoint.decryptTarget]
                ) {
                  <span class="decrypt-cell">
                    {{
                      tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
                    }}
                    <button
                      type="button"
                      class="ms-1 decrypt-button"
                      mat-icon-button
                      matTooltip="Click to see raw value"
                      [matTooltipShowDelay]="500"
                      (click)="
                        decryptValue(
                          tradeDetail[infoPoint.decryptTarget],
                          infoPoint.label
                        )
                      "
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </span>
                } @else {
                  {{ tradeDetail.Details[infoPoint.varSet][infoPoint.varName] }}
                }
              } @else if (!infoPoint.varSet && tradeDetail[infoPoint.varName]) {
                @if (infoPoint.valueMask && infoPoint.valueMask === 'date') {
                  {{ tradeDetail[infoPoint.varName] | date: 'shortDate' }}
                } @else if (
                  infoPoint.valueMask && infoPoint.valueMask === 'currency'
                ) {
                  <span>{{ tradeDetail[infoPoint.varName] | currency }}</span>
                } @else if (
                  infoPoint.valueMask && infoPoint.valueMask === 'percent'
                ) {
                  <span>{{ tradeDetail[infoPoint.varName] | percent }}</span>
                } @else {
                  {{ tradeDetail[infoPoint.varName] }}
                }
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
<ngx-loading [show]="loading" />
